module.exports = __webpack_public_path__ + "static/media/chart.ce00b9ef.mov";


//////////////////
// WEBPACK FOOTER
// ./src/videos/chart.mov
// module id = 388
// module chunks = 0